<script lang="ts">
    import { Tooltip } from '@allibee/components/basic';
    import type { NodeViewProps } from '@tiptap/core';

    import { NodeViewWrapper } from 'svelte-tiptap';
    import { twMerge } from 'tailwind-merge';

    export let node: NodeViewProps['node'];
    export let deleteNode: NodeViewProps['deleteNode'];

    $$restProps;
</script>

<NodeViewWrapper class="bg-primary-50 my-1 rounded-lg" draggable="true" data-drag-handle>
    {#if node.attrs['data-removable']}
        <div class={twMerge('flex cursor-grab items-center justify-between px-3 pb-2 pt-3', node.attrs['data-removable'] && 'text-green-600')} contenteditable="false">
            <p class="flex items-center gap-1 text-xs font-semibold">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.76172 9.69727V2.25H9.53455V3.3712H6.09894V5.40789H9.20539V6.52909H6.09894V9.69727H4.76172Z" fill="currentColor" />
                    <path d="M3.37237 2.25V9.69727H2.03516V2.25H3.37237Z" fill="currentColor" />
                </svg>
                {node.attrs['data-name']}
            </p>
            <button on:click={deleteNode}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 8.5V11.5M10 8.5V11.5M5 6.5H13M12.5 6.5L12.0665 12.571C12.0485 12.8233 11.9356 13.0594 11.7506 13.2318C11.5655 13.4042 11.3219 13.5 11.069 13.5H6.931C6.67807 13.5 6.43453 13.4042 6.24944 13.2318C6.06435 13.0594 5.95146 12.8233 5.9335 12.571L5.5 6.5H12.5ZM10.5 6.5V5C10.5 4.86739 10.4473 4.74021 10.3536 4.64645C10.2598 4.55268 10.1326 4.5 10 4.5H8C7.86739 4.5 7.74021 4.55268 7.64645 4.64645C7.55268 4.74021 7.5 4.86739 7.5 5V6.5H10.5Z"
                        stroke="#636570"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <Tooltip>블록 삭제</Tooltip>
        </div>
    {/if}
    <div data-node-view-content class={twMerge('cursor-text', node.attrs['data-removable'] && 'px-3 pb-3')} />
</NodeViewWrapper>
